export default {
	title: "Roues Chanceuses",
	Lucky: "Chanceux",
	wheels: "Roues",
	winningrecord: "Historique des Gains",
	ActivityRules: "Règles de l'Activité",
	ActivityRulesContent: "Pour plus d'informations sur le tirage au sort, veuillez contacter notre service client.",
	award: {
		title: "Félicitations pour votre gain !",
		btn: "Recevoir le prix"
	},
	noticeItem: "{0} a obtenu {1}",
	lotteryDraws: "{0} tirages au sort",
	noAvailableTimes: "Tentatives insuffisantes disponibles. Veuillez contacter le service client.",
	noOpen: "Pas encore ouvert",
	noWinning: "Continuez vos efforts",
	ViewALlPrizes: "Voir tous les prix",
	myPrizes: "Mes prix",
	share: "Partager avec un ami"
};
